
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlB as ObiOwnShipControlBElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-b.js';
 
 
 

 
 export const ObiOwnShipControlB = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-b',
   elementClass: ObiOwnShipControlBElement,
   events: {
     
   }
  });
 
 